<template>
  <div class="hero-section">
    <div class="container">
      <div class="row">
        <div class="col-12 col-xl-5 offset-xl-1">
          <div class="content">
            <!-- <h1>Your quick & simple <br>asset-based loans</h1> -->
            <slot></slot>
          </div>
        </div>
        <div class="col-12 col-xl-5 px-0 position-relative">
          <div class="image-wrapper">
            <img
              :src="`/static/assets/imgs/${imageName}`"
              :srcset="`/static/assets/imgs/${imageName.substring(0, imageName.lastIndexOf('.'))}-320w${imageName.substring(imageName.lastIndexOf('.'))} 320w, /static/assets/imgs/${imageName.substring(0, imageName.lastIndexOf('.'))}-640w${imageName.substring(imageName.lastIndexOf('.'))} 640w, /static/assets/imgs/${imageName.substring(0, imageName.lastIndexOf('.'))}-960w${imageName.substring(imageName.lastIndexOf('.'))} 960w`"
              :alt="altText" />
            <!-- <div class="image-overlay"></div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["imageName", "altText"],
  data: function () {
    return {};
  },
};
</script>

<style scoped lang="scss">
@import "../assets/css/index.css";
@import "../assets/css/fonts.css";

.hero-section {
  background: white;
  font-family: "Helvetica", sans-serif;
  width: 100%;
  max-width: 1920px;
  margin-left: auto;
  margin-right: auto;

  .content {
    padding-top: 40px;
    padding-bottom: 40px;
    @media (min-width: 1200px) {
      padding-top: 150px;
      padding-bottom: 150px;
    }
  }

  h1 {
    font-family: "Biotif", "Helvetica", sans-serif;
    font-weight: 700;
    font-size: 24px;
    margin-top: 0;
    margin-bottom: 16px;
    @media (min-width: 1200px) {
      font-size: 54px;
      margin-bottom: 38px;
    }
    @media (max-width: 768px) {
      font-size: 30px !important;
    }
  }

  button {
    background-color: rgb(84, 86, 255);
    color: #ffffff;
    font-size: 16px;
    font-weight: 700;
    height: 53px;
    width: 169px;
    border-radius: 26.5px;
    border: none;
  }

  p {
    font-size: 18px;
    line-height: 30px;
    color: #696969;
    font-weight: 400;
    margin-top: 32px;

    @media (max-width: 1199px) {
      a {
        display: block;
      }
    }

    &:not(:last-child) {
      margin-bottom: 40px;
    }
  }

  a {
    color: #5456ff;
  }

  .image-wrapper {
    padding: 90px 0;
    width: 100vw;
    height: 100%;
    overflow-x: hidden;
    position: relative;

    @media (min-width: 1200px) {
      position: absolute;
      width: unquote("min(50vw, 960px)");
    }

    img {
      height: 100%;
      position: relative;
      right: 0;
      top: 0;
      width: 100%;

      @media (min-width: 1200px) {
        object-fit: contain;
        object-position: left;
      }
    }

    .image-overlay {
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      width: 100%;
      height: 20%;
      z-index: 3;
      background: linear-gradient(
        to bottom,
        rgba(255, 255, 255, 1),
        rgba(255, 255, 255, 0)
      );

      @media (min-width: 1200px) {
        top: 0;
        bottom: 0;
        left: 0;
        right: unset;
        width: 33%;
        height: 100%;
        z-index: 3;
        background: linear-gradient(to right, white, rgba(255, 255, 255, 0));
      }
    }
  }

  &.img-left {
    .image-wrapper {
      img {
        @media (min-width: 1200px) {
          object-position: left;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Hero.vue?059fd808